<template>
  <div
    class="bg-[#23242A] text-white app-header custom"
    id="content_screen"
  >
    <div class="flex content-main gap-5">
      <div class="custom-full">
        <div class="bg-[#2B2C32] rounded-lg max-w-full py-[16px]">
          <div class="flex justify-between px-[16px]" :class="split?'flex-col gap-5 h-[80px] mb-6':'flex-row h-[40px]'">
            <div class="flex flex-row items-center gap-2">
              <h2 class="text-[20px] font-bold tracking-wider text-white">
                Add Purchase Order
              </h2>
            </div>
            <div class="flex flex-row items-center gap-[24px]">
              <button @click="back"
                class="cursor-pointer text-sm font-medium tracking-widest rounded text-[#DC3545] bg-white py-2 px-3 disabled:bg-opacity-50 uppercase"
              >
                Exit
              </button>
              <button
                :disabled="!allGreenYellow || disableConfirmInventory"
                @click="confirmInventory"
                class="cursor-pointer text-sm font-medium tracking-widest rounded text-white bg-theme-green disabled:text-[#9E9E9E] disabled:bg-[#414141] py-2 px-3 "
              >
              CONFIRM INVENTORY
              </button>
              <div class="h-[34px] border-r border-r-[#464851]"></div>
              <button class="flex items-center py-[8px] gap-[8px]">
                <span class="font-[400] text-[14px]">AutoSave</span>
                <svg width="19" height="21" viewBox="0 0 19 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 0V6C8 6.53043 7.78929 7.03914 7.41421 7.41421C7.03914 7.78929 6.53043 8 6 8H0V18C0 18.5304 0.210714 19.0391 0.585787 19.4142C0.960859 19.7893 1.46957 20 2 20H8.81C7.77498 18.9226 7.14271 17.5215 7.0196 16.0326C6.89649 14.5436 7.29005 13.0578 8.13405 11.825C8.97805 10.5922 10.221 9.68779 11.6536 9.26397C13.0862 8.84016 14.6211 8.9228 16 9.498V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0H8ZM6.5 0.5V6C6.5 6.13261 6.44732 6.25979 6.35355 6.35355C6.25979 6.44732 6.13261 6.5 6 6.5H0.5L6.5 0.5ZM19 15.5C19 16.2223 18.8577 16.9375 18.5813 17.6048C18.3049 18.2721 17.8998 18.8784 17.3891 19.3891C16.8784 19.8998 16.272 20.3049 15.6048 20.5813C14.9375 20.8577 14.2223 21 13.5 21C12.7777 21 12.0625 20.8577 11.3952 20.5813C10.728 20.3049 10.1216 19.8998 9.61091 19.3891C9.10019 18.8784 8.69506 18.2721 8.41866 17.6048C8.14226 16.9375 8 16.2223 8 15.5C8 14.0413 8.57946 12.6424 9.61091 11.6109C10.6424 10.5795 12.0413 10 13.5 10C14.9587 10 16.3576 10.5795 17.3891 11.6109C18.4205 12.6424 19 14.0413 19 15.5ZM10.5 12C10.3674 12 10.2402 12.0527 10.1464 12.1464C10.0527 12.2402 10 12.3674 10 12.5V14.5C10 14.6326 10.0527 14.7598 10.1464 14.8536C10.2402 14.9473 10.3674 15 10.5 15H12.5C12.6326 15 12.7598 14.9473 12.8536 14.8536C12.9473 14.7598 13 14.6326 13 14.5C13 14.3674 12.9473 14.2402 12.8536 14.1464C12.7598 14.0527 12.6326 14 12.5 14H11.5C11.7327 13.6893 12.0346 13.4371 12.3818 13.2635C12.7289 13.0899 13.1118 12.9997 13.5 13C14.333 13 15.072 13.407 15.527 14.036C15.5648 14.0908 15.6132 14.1375 15.6693 14.1734C15.7255 14.2093 15.7882 14.2336 15.8538 14.2449C15.9195 14.2561 15.9867 14.2542 16.0516 14.2392C16.1165 14.2241 16.1777 14.1962 16.2317 14.1572C16.2856 14.1182 16.3312 14.0687 16.3658 14.0118C16.4004 13.9549 16.4233 13.8916 16.4331 13.8258C16.4429 13.7599 16.4395 13.6927 16.423 13.6282C16.4065 13.5637 16.3772 13.5031 16.337 13.45C16.0128 13.0008 15.5865 12.6351 15.0933 12.383C14.6 12.1309 14.0539 11.9996 13.5 12C12.52 12 11.635 12.403 11 13.05V12.5C11 12.3674 10.9473 12.2402 10.8536 12.1464C10.7598 12.0527 10.6326 12 10.5 12ZM16 17.95V18.5C16 18.6326 16.0527 18.7598 16.1464 18.8536C16.2402 18.9473 16.3674 19 16.5 19C16.6326 19 16.7598 18.9473 16.8536 18.8536C16.9473 18.7598 17 18.6326 17 18.5V16.5C17 16.3674 16.9473 16.2402 16.8536 16.1464C16.7598 16.0527 16.6326 16 16.5 16H14.5C14.3674 16 14.2402 16.0527 14.1464 16.1464C14.0527 16.2402 14 16.3674 14 16.5C14 16.6326 14.0527 16.7598 14.1464 16.8536C14.2402 16.9473 14.3674 17 14.5 17H15.5C15.044 17.608 14.317 18 13.5 18C12.734 18 12.048 17.656 11.589 17.112C11.5027 17.0132 11.3811 16.9523 11.2503 16.9423C11.1195 16.9324 10.9901 16.9742 10.8898 17.0588C10.7896 17.1434 10.7267 17.264 10.7145 17.3946C10.7024 17.5252 10.7421 17.6554 10.825 17.757C11.1532 18.1468 11.5628 18.46 12.0249 18.6747C12.487 18.8894 12.9904 19.0005 13.5 19C13.9657 19.0006 14.4268 18.908 14.8561 18.7277C15.2855 18.5474 15.6744 18.283 16 17.95Z" fill="white"/>
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div v-if="isInactiveMarkupPrice()" class="bg-[#E7A644] bg-opacity-10 p-2 mt-4 rounded grow">
            <div class="flex items-center ">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 11.75C8.2125 11.75 8.39063 11.6781 8.53438 11.5344C8.67813 11.3906 8.75 11.2125 8.75 11V8C8.75 7.7875 8.67813 7.60938 8.53438 7.46563C8.39063 7.32188 8.2125 7.25 8 7.25C7.7875 7.25 7.60938 7.32188 7.46563 7.46563C7.32188 7.60938 7.25 7.7875 7.25 8V11C7.25 11.2125 7.32188 11.3906 7.46563 11.5344C7.60938 11.6781 7.7875 11.75 8 11.75ZM8 5.75C8.2125 5.75 8.39063 5.67813 8.53438 5.53438C8.67813 5.39062 8.75 5.2125 8.75 5C8.75 4.7875 8.67813 4.60938 8.53438 4.46563C8.39063 4.32188 8.2125 4.25 8 4.25C7.7875 4.25 7.60938 4.32188 7.46563 4.46563C7.32188 4.60938 7.25 4.7875 7.25 5C7.25 5.2125 7.32188 5.39062 7.46563 5.53438C7.60938 5.67813 7.7875 5.75 8 5.75ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5ZM8 14C9.675 14 11.0938 13.4188 12.2563 12.2563C13.4188 11.0938 14 9.675 14 8C14 6.325 13.4188 4.90625 12.2563 3.74375C11.0938 2.58125 9.675 2 8 2C6.325 2 4.90625 2.58125 3.74375 3.74375C2.58125 4.90625 2 6.325 2 8C2 9.675 2.58125 11.0938 3.74375 12.2563C4.90625 13.4188 6.325 14 8 14Z" fill="#E7A644"/>
                </svg>
                <span class="pl-3 text-theme-orange text-sm">Mark up is not set</span>
            </div>
            <div  class="text-sm">You are missing mark up settings for the following compliance types: <span class="capitalize font-bold">{{ getInactiveMarkup() }}</span> . These compliance types will be set to 50% until it is set up</div>
        </div>
        
        <div class="bg-[#2B2C32] rounded-lg max-w-full py-[16px] mt-[16px]">
          <div class="flex justify-between px-[16px] h-[40px]">
            <div class="flex flex-row items-center gap-2">
              <h2 class="text-xl font-bold tracking-wider text-white">
                Details
              </h2>
            </div>
          </div>

          <div class="grid mx-4 gap-4 p-[8px]" :class="split?'grid-cols-2':'grid-cols-4'">
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Shipment ID *</label>
              <input
                @change="updatePurchaseOrder()"
                v-model="form.shipmentId.value"
                placeholder="Purchase Order # - 00998888"
                class="block border-0 rounded bg-[#464851] w-full text-sm"
                type="text"
              />
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Date</label>
              <input
                disabled
                :value="payload.date"
                placeholder="2023-03-24"
                class="block border-0 rounded bg-[#464851] w-full text-sm"
                type="text"
              />
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Location *</label>
              <select v-model="form.location.value" @change="updatePurchaseOrder()" class="cursor-pointer w-full h-[40px] bg-[#464851] border-[#464851] focus:outline-0 font-normal text-base leading-5 text-white p-2 rounded">
                <option v-for="each in vg_locations" :key="each.id" :value="each.id">{{each.name}}{{ each.businessBrandProfile?.name ? ' [' + each.businessBrandProfile?.name + ']' : '' }}</option>
              </select>
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Employee</label>
              <input
                disabled
                v-model="form.createdByName.value"
                @change="updatePurchaseOrder()"
                placeholder="John Crenwich"
                class="block border-0 rounded bg-[#464851] w-full text-sm"
                type="text"
              />
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Shipping Cost</label>
              <div class="block border-0 rounded bg-[#464851] w-full">
                <span v-if="form.shippingCost.value" class="relative pl-2">$</span>
                <input
                  @change="updatePurchaseOrder()"
                  v-model="form.shippingCost.value"
                  class="rounded border-0 bg-[#464851] focus:ring-0 pl-1 text-sm"
                  type="text"
                />
              </div>
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Tax Cost</label>
              <div class="block border-0 rounded bg-[#464851] w-full">
                <span v-if="form.tax.value" class="relative pl-2">$</span>
                <input
                  @change="updatePurchaseOrder()"
                  v-model="form.tax.value"
                  class="rounded border-0 bg-[#464851] focus:ring-0 pl-1 text-sm"
                  type="text"
                />
              </div>
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Total Cost</label>
              <div class="block border-0 rounded bg-[#464851] w-full">
                <span v-if="form.total.value" class="relative pl-2">$</span>
                <input
                  @change="updatePurchaseOrder()"
                  v-model="form.total.value"
                  class="rounded border-0 bg-[#464851] focus:ring-0 pl-1 text-sm"
                  type="text"
                />
              </div>
            </div>
            <div class="w-full input-wrapper">
              <label class="text-xs mb-1">Fulfillment Time</label>
              <input
                @change="updatePurchaseOrder()"
                v-model="form.fullfillmentTime.value"
                class="block border-0 rounded bg-[#464851] w-full text-sm"
                type="text"
                maxlength="4"
              />
              <span v-if="form.fullfillmentTime.value" class="relative top-[-30px] left-[50px]">days</span>
              <div class="flex items-start gap-[8px]">
                <div class="text-[12px] pt-1">Fulfilment time is used for your re-order report when calculating how long it will take items to restock</div>
                <div class="w-[16px] h-[16px] pt-1">
                  <svg  width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00016 1.33301C4.32016 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 11.6797 4.32016 14.6663 8.00016 14.6663C11.6802 14.6663 14.6668 11.6797 14.6668 7.99967C14.6668 4.31967 11.6802 1.33301 8.00016 1.33301ZM7.3335 4.66634V5.99967H8.66683V4.66634H7.3335ZM7.3335 7.33301V11.333H8.66683V7.33301H7.3335ZM2.66683 7.99967C2.66683 10.9397 5.06016 13.333 8.00016 13.333C10.9402 13.333 13.3335 10.9397 13.3335 7.99967C13.3335 5.05967 10.9402 2.66634 8.00016 2.66634C5.06016 2.66634 2.66683 5.05967 2.66683 7.99967Z" fill="white"/>
                  </svg>
              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="bg-[#2B2C32] mt-5 pb-5 rounded-lg max-w-full">
            <div class="w-full">
              <div class="flex justify-between p-[16px]">
                <div class="font-[700] text-[20px] ">Product List</div>
              </div>

              <div class="flex mx-4">
                <PoInfo :items="items" :costChanges="costChanges" @selectedProduct="selectedRow" />
              </div>

              <div class="mx-4 flex gap-4 items-center justify-center mb-6">
                <div class="flex-1">
                  <SearchProduct :searchString="searchString" @changeSearchProduct="changeSearchProduct" />
                </div>
                <div class="w-0.5 h-11 bg-zinc-700"></div>
                <div class="h-12 px-4 py-2 bg-theme-green rounded-md flex justify-center items-center gap-2 overflow-hidden">
                  <button @click="showAddProductModal" class="justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest hover:bg-theme-green/10">Add Product</button>
                </div>
              </div>


              <Progress :counts="{red: type.red, grey: type.grey, yellow: type.yellow, green: type.green, blue: type.blue }" />

              <div v-if="originalType.red!==0 || originalType.grey!==0 || originalType.yellow!=0" class="tab flex p-4 my-5 min-w-[800px]" :class="split?'gap-[0px]':'gap-[24px]'">
                <div v-if="originalType.red>0" @click="switchSelectedType('red')" class="cursor-pointer flex w-[160px] h-[36px] items-center justify-center text-white text-[16px] font-700" :class="selectedType==='red'?'bg-[#DC3545CC] bg-opacity-80 rounded-t-md':'border-b-[4px] border-b-[#DC3545CC]'">Empty Products {{ type.red }}</div>
                <div v-if="originalType.grey>0" @click="switchSelectedType('grey')" class="cursor-pointer flex w-[70px] h-[36px] items-center justify-center text-white text-[16px] font-700" :class="selectedType==='grey'?'bg-[#87868699] bg-opacity-60 rounded-t-md':'border-b-[4px] border-b-[#87868699]'">New {{  type.grey }}</div>
                <div v-if="originalType.yellow>0" @click="switchSelectedType('yellow')" class="cursor-pointer flex w-[196px] h-[36px] items-center justify-center text-white text-[16px] font-700" :class="selectedType==='yellow'?'bg-[#FCB85299] bg-opacity-60 rounded-t-md':'border-b-[4px] border-b-[#FCB85299]'">Missing Cannabinoids {{ type.yellow}}</div>
                <div v-if="originalType.green>0" @click="switchSelectedType('green')" class="cursor-pointer flex w-[153px] h-[36px] items-center justify-center text-white text-[16px] font-700" :class="selectedType==='green'?'bg-[#2BA66B99] bg-opacity-60 rounded-t-md':'border-b-[4px] border-b-[#2BA66B99]'">Replenishments {{  type.green }}</div>
                <div v-if="originalType.blue>0" @click="switchSelectedType('blue')" class="cursor-pointer flex w-[153px] h-[36px] items-center justify-center text-white text-[16px] font-700" :class="selectedType==='blue'?'bg-[#7A9DFF99] bg-opacity-60 rounded-t-md':'border-b-[4px] border-b-[#7A9DFF99]'">Confirmed Stock {{  type.blue }}</div>
              </div>
            </div>

            <div v-if="warning" class="bg-[#E7A644] bg-opacity-10 p-2 mt-4 mx-4 rounded w-[510px]">
              <div class="flex items-center">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 11.75C8.2125 11.75 8.39063 11.6781 8.53438 11.5344C8.67813 11.3906 8.75 11.2125 8.75 11C8.75 10.7875 8.67813 10.6094 8.53438 10.4656C8.39063 10.3219 8.2125 10.25 8 10.25C7.7875 10.25 7.60938 10.3219 7.46563 10.4656C7.32188 10.6094 7.25 10.7875 7.25 11C7.25 11.2125 7.32188 11.3906 7.46563 11.5344C7.60938 11.6781 7.7875 11.75 8 11.75ZM8 8.75C8.2125 8.75 8.39063 8.67813 8.53438 8.53438C8.67813 8.39063 8.75 8.2125 8.75 8V5C8.75 4.7875 8.67813 4.60938 8.53438 4.46563C8.39063 4.32188 8.2125 4.25 8 4.25C7.7875 4.25 7.60938 4.32188 7.46563 4.46563C7.32188 4.60938 7.25 4.7875 7.25 5V8C7.25 8.2125 7.32188 8.39063 7.46563 8.53438C7.60938 8.67813 7.7875 8.75 8 8.75ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5Z" fill="#FCB852"/>
                </svg>
                <span class="pl-3 text-theme-orange text-[12px]">If cannabinoid fields are left blank, the values will be pulled from our database.</span>
                <svg class="ml-[5px] cursor-pointer" @click="closeWarning" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z" fill="white"/>
                </svg>
              </div>
            </div>
            
            <new-table-lite
                :is-static-mode="true"
                :is-slot-mode="true"
                :is-loading="table.loading"
                :class="'block w-full admin-purchase-order'"
                :rowClasses="row => 'id-'+row.id"
                :columns="table.columns"
                :rows="table.rows"
                :page="table.page"
                :total="table.totalRecords"
                :sortable="table.sortable"
                :page-size="table.pagesize"
                @do-search="changePage"
                @row-clicked="selectedRow"
                :pageOptions='table.pageOptions'
                :messages="{
                    pagingInfo: 'Total: {2}',
                    pageSizeChangeLabel: 'Items per Page',
                    gotoPageLabel: 'Go to page',
                    noDataAvailable: 'No records found!',
                }"
            >
            <template v-slot:name="data">
              <div>
                <div v-if="data.value?.name" class="flex justify-start items-start">
                  <div v-if="!data.value.name || !data.value.variantName || (!data.value.nou && data.value.nou!==0)">
                    <svg class="w-[20px] h-[20px] m-[5px]" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.58832 12.25C1.48138 12.25 1.38415 12.2233 1.29665 12.1698C1.20915 12.1163 1.1411 12.0458 1.09249 11.9583C1.04388 11.8708 1.01714 11.776 1.01228 11.674C1.00742 11.5719 1.03415 11.4722 1.09249 11.375L6.48832 2.04167C6.54665 1.94444 6.622 1.87153 6.71436 1.82292C6.80672 1.77431 6.90152 1.75 6.99874 1.75C7.09596 1.75 7.19075 1.77431 7.28311 1.82292C7.37547 1.87153 7.45082 1.94444 7.50915 2.04167L12.905 11.375C12.9633 11.4722 12.9901 11.5719 12.9852 11.674C12.9803 11.776 12.9536 11.8708 12.905 11.9583C12.8564 12.0458 12.7883 12.1163 12.7008 12.1698C12.6133 12.2233 12.5161 12.25 12.4092 12.25H1.58832ZM2.59457 11.0833H11.4029L6.99874 3.5L2.59457 11.0833ZM6.99874 10.5C7.16402 10.5 7.30256 10.4441 7.41436 10.3323C7.52617 10.2205 7.58207 10.0819 7.58207 9.91667C7.58207 9.75139 7.52617 9.61285 7.41436 9.50104C7.30256 9.38924 7.16402 9.33333 6.99874 9.33333C6.83346 9.33333 6.69492 9.38924 6.58311 9.50104C6.47131 9.61285 6.4154 9.75139 6.4154 9.91667C6.4154 10.0819 6.47131 10.2205 6.58311 10.3323C6.69492 10.4441 6.83346 10.5 6.99874 10.5ZM6.99874 8.75C7.16402 8.75 7.30256 8.6941 7.41436 8.58229C7.52617 8.47049 7.58207 8.33194 7.58207 8.16667V6.41667C7.58207 6.25139 7.52617 6.11285 7.41436 6.00104C7.30256 5.88924 7.16402 5.83333 6.99874 5.83333C6.83346 5.83333 6.69492 5.88924 6.58311 6.00104C6.47131 6.11285 6.4154 6.25139 6.4154 6.41667V8.16667C6.4154 8.33194 6.47131 8.47049 6.58311 8.58229C6.69492 8.6941 6.83346 8.75 6.99874 8.75Z" fill="#FCB852"/>
                    </svg>
                  </div>
                  <div v-else class=" w-[20px] h-[20px] rounded m-[5px]" :style="`background: ${data.value.product?.category?.posColour}`"></div>
                  <div class="flex flex-col gap-[5px]">
                    <div>{{ data.value?.name }}</div>
                    <div v-if="data.value?.batchLot">{{ data.value?.batchLot }}</div>
                  </div>
                </div>
                <div v-else>
                  <input name="name" tabIndex="1" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[100px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'name')" :value="data.value.name" @change="updateField('name', data.value, $event)" />
                </div>
              </div>
            </template>
            <template v-slot:variantName="data">
              <span v-if="data.value.variantName" class="flex items-center ml-2">{{ data.value.variantName }}</span>
              <input v-else name="variantName" tabIndex="1" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[100px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'variantName')" :value="data.value.variantName" @change="updateField('variantName', data.value, $event)" />
            </template>
            <template v-slot:packSize="data">
              <div v-if="data.value?.packSize">{{ data.value?.packSize }}</div>
              <div v-else></div>
            </template>
            <template v-slot:lotMatched="data">
              <svg v-if="data.value?.lotMatched" class="w-[24px] h-[36px] fill-theme-green" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
              </svg>
            </template>
            <template v-slot:thc="data">
                <input v-if="data.value.product?.complianceType?.toLowerCase()!=='accessory'" :disabled="data.value.qtyAdded" name="thc" tabIndex="1" type="number" min="0" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[50px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'thc')" :value="data.value.thc" @change="updateField('thc', data.value, $event)" />
                <span v-else class="flex items-center ml-2">-</span>
            </template>
            <template v-slot:cbd="data">
                <input v-if="data.value.product?.complianceType?.toLowerCase()!=='accessory'" :disabled="data.value.qtyAdded" name="cbd" tabIndex="1" type="number" min="0" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[50px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'cbd')" :value="data.value.cbd" @change="updateField('cbd', data.value, $event)" />
                <span v-else class="flex items-center ml-2">-</span>
            </template>
            <template v-slot:totalTerp="data">
              <input v-if="data.value.product?.complianceType?.toLowerCase()!=='accessory'" :disabled="data.value.qtyAdded" name="totalTerp" tabIndex="1" type="number" min="0" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[50px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'totalTerp')" :value="data.value.totalTerp" @change="updateField('totalTerp', data.value, $event)" />
              <span v-else class="flex items-center ml-2">-</span>
            </template>
            <template v-slot:nou="data">
              <input name="nou" tabIndex="1" type="number" min="0" :disabled="data.value.qtyAdded" @keydown.up.prevent="false" @keydown.down.prevent="false" class="flex items-center justify-center h-[34px] w-[50px] px-[5px] bg-transparent border rounded" :class="getBorderClass(selectedType, data, 'nou')" :value="data.value.nou" @change="updateField('nou', data.value, $event)" />
            </template>
            <template v-slot:action="data">
              <div v-if="!data.value.qtyAdded" class="flex items-center gap-1">
                <svg @click.stop="removeProduct(data.value)" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 3V4H4V6H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z" fill="#F53333"/>
                </svg>
                <button v-if="data.value.product?.category?.id" @click.stop="confirmIndividualOrder(data.value.id)" class="cursor-pointer flex items-center gap-1 text-white bg-theme-green hover:bg-theme-green/80 px-3 py-2 rounded rounded-full">
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.18464 8.04935L4.93047 6.79518C4.82352 6.68824 4.68741 6.63477 4.52214 6.63477C4.35686 6.63477 4.22075 6.68824 4.1138 6.79518C4.00686 6.90213 3.95339 7.03824 3.95339 7.20352C3.95339 7.36879 4.00686 7.5049 4.1138 7.61185L5.7763 9.27435C5.89297 9.39102 6.02908 9.44935 6.18464 9.44935C6.34019 9.44935 6.4763 9.39102 6.59297 9.27435L9.8888 5.97852C9.99575 5.87157 10.0492 5.73546 10.0492 5.57018C10.0492 5.4049 9.99575 5.26879 9.8888 5.16185C9.78186 5.0549 9.64575 5.00143 9.48047 5.00143C9.31519 5.00143 9.17908 5.0549 9.07214 5.16185L6.18464 8.04935ZM7.0013 12.8327C6.19436 12.8327 5.43602 12.6796 4.7263 12.3733C4.01658 12.0671 3.39922 11.6514 2.87422 11.1264C2.34922 10.6014 1.93359 9.98407 1.62734 9.27435C1.32109 8.56463 1.16797 7.80629 1.16797 6.99935C1.16797 6.1924 1.32109 5.43407 1.62734 4.72435C1.93359 4.01463 2.34922 3.39727 2.87422 2.87227C3.39922 2.34727 4.01658 1.93164 4.7263 1.62539C5.43602 1.31914 6.19436 1.16602 7.0013 1.16602C7.80825 1.16602 8.56658 1.31914 9.2763 1.62539C9.98602 1.93164 10.6034 2.34727 11.1284 2.87227C11.6534 3.39727 12.069 4.01463 12.3753 4.72435C12.6815 5.43407 12.8346 6.1924 12.8346 6.99935C12.8346 7.80629 12.6815 8.56463 12.3753 9.27435C12.069 9.98407 11.6534 10.6014 11.1284 11.1264C10.6034 11.6514 9.98602 12.0671 9.2763 12.3733C8.56658 12.6796 7.80825 12.8327 7.0013 12.8327ZM7.0013 11.666C8.30408 11.666 9.40755 11.2139 10.3117 10.3098C11.2159 9.4056 11.668 8.30213 11.668 6.99935C11.668 5.69657 11.2159 4.5931 10.3117 3.68893C9.40755 2.78477 8.30408 2.33268 7.0013 2.33268C5.69852 2.33268 4.59505 2.78477 3.69089 3.68893C2.78672 4.5931 2.33464 5.69657 2.33464 6.99935C2.33464 8.30213 2.78672 9.4056 3.69089 10.3098C4.59505 11.2139 5.69852 11.666 7.0013 11.666Z" fill="white"/>
                  </svg>
                  Confirm
                </button>
              </div>
            </template>
            </new-table-lite>
        </div>
      </div>
    </div>
    <AddProduct v-if="addProductModal" :payload="payload" @add="addProduct" @resetSearchClose="resetSearchClose()" @close="addProductModal = false" />
  </div>
</template>

<script>
import { defineComponent, ref} from 'vue'
import { useSnackbar } from "vue3-snackbar";
import { mapGetters, mapMutations, mapActions} from "vuex";

import Env from '@/env';
import Helpers from '@/helpers';
import ProductHelper from '@/helpers/product'

// components
import NewTableLite from '@/components/table/tableLite.vue'
import SelectLocations from '@/components/form/SelectLocations.vue'
import Progress from '@/views/Products/PurchaseOrder/PurchaseOrderAdd/Progress.vue'
import SearchProduct from "./SearchProduct.vue"
import AddProduct from './AddProduct.vue'
import PoInfo from './Info.vue';

// apis
import ProductApi from '@/controllers/BusinessProductApis'
import PriceMarkupSettingApis from "@/controllers/LocationMarkupPrice";
import LocationComplianceApis from '@/controllers/LocationComplianceApis';


export default defineComponent({
  props: ['split'],
  components: {
    NewTableLite,
    SelectLocations,
    Progress,
    SearchProduct,
    PoInfo,
    AddProduct
  },
  setup() {
    const snackbar = useSnackbar();
    const loading = false
    const table = ref({
        loading: false,
        columns: [],
        rows: [],
        totalRecords: 0,
        page: 1,
        pagesize: 25,
        sortable: {
            order: "productName",
            sort: "asc",
        },
        count: 0,
        clearChecked: false,
    })
    const mainColumn = [
      {
        label: 'Id', 
        field: 'id', 
        sortable:false, 
        isKey:true, 
        columnClasses:'hidden', 
        headerClasses:'hidden' 
      },
      {
        label: "Name",
        field: "name",
        sortable: true,
      },
      {
        label: "Category",
        field: "category",
        sortable: true,
      },
      {
        label: "Variant Name",
        field: "variantName",
        sortable: true,
      },
      {
        label: "Brand",
        field: "brand",
        sortable: true,
      },
      {
        label: "Lot Matched",
        field: "lotMatched",
        sortable: false,
      },
      {
        label: "THC",
        field: "thc",
        sortable: false,
      },
      {
        label: "CBD",
        field: "cbd",
        sortable: false,
      },
      {
        label: "Terps",
        field: "totalTerp",
        sortable: false,
      },
      {
        label: "Unit",
        field: "concentrationUnit",
        sortable: false,
      },
      {
        label: "Case",
        field: "packSize",
        sortable: true,
      },
      {
        label: "Qty",
        field: "nou",
        sortable: true,
      },
      {
        label: "",
        field: "action",
        sortable: false,
        width: '40px'
      }
    ]
    const halfColumn = [
      {
        label: 'Id', 
        field: 'id', 
        sortable:false, 
        isKey:true, 
        columnClasses:'hidden', 
        headerClasses:'hidden' 
      },
      {
        label: "Name",
        field: "name",
        sortable: true,
      },
      {
        label: "Variant Name",
        field: "variantName",
        sortable: true,
      },
      {
        label: "Brand",
        field: "brand",
        sortable: true,
      },
    ]
    const form = ref({
      shipmentId: {
        value: ''
      },
      location: {
        value: ''
      },
      createdByName: {
        value: '',
      },
      shippingCost: {
        value: '',
      },
      tax: {
        value: '',
      },
      total: {
        value: '',
      },
      status: {
        value: 'inprogress',
      },
      fullfillmentTime: {
        value: ''
      }
    })
    const shipmentId = ref('')
    const activeItem = ref({});
    const originalType = ref({green: 0, grey: 0, yellow: 0, red: 0})
    const type = ref({green: 0, grey: 0, yellow: 0, red: 0})
    const selectedType = ref('red')
    const payload = ref({})
    const costChanges = ref([])
    const items = ref([])
    const allGreenYellow = ref(false)
    const markupPrices = ref([])
    const warning = ref(true)
    const disableConfirmInventory = ref(false)
    const addProductModal = ref(false)
    const searchString = ref('')

    return {snackbar, loading, table, form, shipmentId, activeItem, selectedType, payload, costChanges, items, originalType, type, mainColumn, halfColumn, allGreenYellow, markupPrices, warning, disableConfirmInventory, addProductModal, searchString}
  },
  async mounted(){
    this.loading = true
    await this.fetchList()
    await this.getMarkup()
    await this.getComplianceProvider()
    let self= this
    setTimeout(function(){
      self.loading = false
    },1000)
    this.emitter.on("reloadAddAsnList", this.fetchList);
  },
  beforeDestroy() {
    this.emitter.off("reloadAddAsnList", this.fetchList);
  },
  computed: {
    ...mapGetters({
      vg_user: 'auth/user',
      vg_locations: 'location/list',
      vg_selectedLocation: 'location/selected'
    })
  },
  watch: {
    vg_selectedLocation(){
      this.getComplianceProvider()
    },
    split(val){
      if(val){
        this.table.columns = this.halfColumn
      }else{
        this.table.columns = this.mainColumn
      }
    },
    async searchString(){
      await this.countItems()
      this.filterItems(this.selectedType)
    }
  },
  methods: {
    showAddProductModal(){
      this.addProductModal = true
    },
    resetSearchClose(){
      this.searchString = ''
      this.addProductModal = false
    },
    changeSearchProduct(search){
      this.searchString = search
    },
    switchSelectedType(type){
      if(type){
        this.selectedType = type
        this.table.page = 1
        this.filterItems(type)
      }
    },
    async getComplianceProvider(){
        let res = await LocationComplianceApis.fetch();
        let aglcOcs = 'ocs'
        if(res?.data?.payload?.providerName){
            aglcOcs = res.data.payload.providerName
        }
        this.vm_complianceType(aglcOcs)
    },
    closeWarning(){
      this.warning = false
    },
    getBorderClass(selectedType, data, type){
      if(selectedType==='yellow'  && (!data.value[type] && data.value[type]!==0)){
        return 'border-[#FCB852]'
      }else if((selectedType==='red'|| selectedType==='grey') && (!data.value[type] && data.value[type]!==0)){
        return 'border-[#F53333]'
      }else{
        return 'border-[#464851]'
      }
    },
    changePage(offset, limit, col, order, pageSize){
      this.table.pagesize = pageSize
      this.table.page = (offset/limit)+1
    },
    async fetchList(spinner=true){
      if(this.$route?.params?.id){
        spinner?this.va_spinner(true):null
        let res = await ProductApi.getPurchaseOrderById(this.$route.params.id)
        if(res.status == 200){
          this.payload = res.data.payload.orderWithItems
          this.costChanges = res.data.payload.costChanges
          this.form.shipmentId.value = res.data.payload.orderWithItems.shipmentId
          this.form.createdByName.value = res.data.payload.orderWithItems.createdByName
          this.form.location.value = res.data.payload.orderWithItems.location?.id
          this.form.shippingCost.value = res.data.payload.orderWithItems.shippingCost
          this.form.tax.value = res.data.payload.orderWithItems.tax
          this.form.total.value = res.data.payload.orderWithItems.total
          this.form.fullfillmentTime.value = res.data.payload.orderWithItems.fullfillmentTime
          this.items = res.data.payload.orderWithItems.items
          this.shipmentId = res.data.payload.orderWithItems.shipmentId
          // popup warning on close
          if(res.data.payload.orderWithItems.status!=='completed'){
            this.va_setPurchaseOrderWarning(true)
          }
          await this.countItems()
          await this.countOriginalItems()
          this.filterItems(this.selectedType)
        }
        spinner?this.va_spinner(false):null
      }
    },
    async getMarkup(){
      let res = await PriceMarkupSettingApis.fetchByLocationId(this.vg_selectedLocation.id)
      if(res.status==200){
        this.markupPrices = res.data.payload
        
      }
    },
    isInactiveMarkupPrice(){
      if(this.markupPrices && this.markupPrices.length>0){
        return this.markupPrices.filter(each => !each.status).length>0
      }else{
        return true
      }
    },
    getInactiveMarkup(){
      if(this.markupPrices && this.markupPrices.length>0){
        return this.markupPrices.filter(each => !each.status).map(each => each.complianceType).join(', ')
      }else{
        return 'all'
      }
    },
    countOriginalItems(){
      this.originalType.blue = this.items.filter(each => each.qtyAdded && each.productId!==null && each.product.category).length
      this.originalType.green = this.items.filter(each => !each.qtyAdded && each.productId!==null && each.product.category && (each.product?.complianceType?.toLowerCase()==='accessory' || (each.thc!==null && each.cbd!==null && each.totalTerp!==null))).length
      this.originalType.yellow = this.items.filter(each => !each.qtyAdded && each.productId && each.product.category && (each.product?.complianceoriginalType?.toLowerCase()!=='accessory' && (each.thc===null || each.cbd===null || each.totalTerp==null))).length
      this.originalType.grey = this.items.filter(each => ((each.masterProductId!==null && each.productId===null) || (each.product && !each.product.category))).length
      this.originalType.red = this.items.filter(each => each.masterProductId===null && each.productId===null).length
    },
    async countItems(){
      this.table.columns = this.mainColumn
      const searchTerm = this.searchString ? this.searchString.toLowerCase().trim() : ''
      const matchesSearch = (each) => !searchTerm || (each.name?.toLowerCase().includes(searchTerm) || each.sku?.toLowerCase().includes(searchTerm) || each.productGtin?.includes(searchTerm))

      this.type.blue = this.items.filter(each => matchesSearch(each) && each.qtyAdded && each.productId!==null && each.product.category).length
      this.type.green = this.items.filter(each => matchesSearch(each) && !each.qtyAdded && each.productId!==null && each.product.category && (each.product?.complianceType?.toLowerCase()==='accessory' || (each.thc!==null && each.cbd!==null && each.totalTerp!==null))).length
      this.type.yellow = this.items.filter(each => matchesSearch(each) && !each.qtyAdded && each.productId && each.product.category && (each.product?.complianceType?.toLowerCase()!=='accessory' && (each.thc===null || each.cbd===null || each.totalTerp==null))).length
      this.type.grey = this.items.filter(each => matchesSearch(each) && ((each.masterProductId!==null && each.productId===null) || (each.product && !each.product.category))).length
      this.type.red = this.items.filter(each => matchesSearch(each) && each.masterProductId===null && each.productId===null).length
      this.allGreenYellow = this.type.grey===0 && this.type.red===0

      if(this.type.grey===0 && this.type.red===0 && this.type.yellow===0 && !this.searchString){
        this.selectedType = 'complete'
      }else{
        // only switch tab if current tab is 0
        if(this.type.red!==0){
          this.selectedType = 'red'
        }else if(this.type.grey!==0){
          this.selectedType = 'grey'
        }else if(this.type.yellow!==0){
          this.selectedType = 'yellow'
        }else if(this.type.green!==0){
          this.selectedType = 'green'
        }else if(this.type.blue!==0){
          this.selectedType = 'blue'
        }
      }
    },
    filterItems(selectedType){
      this.table.loading = true
      // get category and variant for sortable
      for(let i=0; i<this.items.length; i++){
        this.items[i].category = this.items[i].product?.category?.name ? this.items[i].product?.category?.name : ''

        if(this.items[i].product?.variantName){
          this.items[i].variant = this.items[i].product?.variantName
        }else if(this.items[i].masterProduct?.size){
          this.items[i].variant = this.items[i].masterProduct?.size
        }else{
          this.items[i].variant = ''
        }
      }

      const searchTerm = this.searchString ? this.searchString.toLowerCase().trim() : ''
      const matchesSearch = (each) => !searchTerm || (each.name?.toLowerCase().includes(searchTerm) || each.sku?.toLowerCase().includes(searchTerm) || each.productGtin?.includes(searchTerm))
      if(selectedType==='blue'){
        this.table.rows = this.items.filter(each => matchesSearch(each) && each.qtyAdded && each.productId!==null && each.product.category)
      }else if(selectedType==='green'){
        this.table.rows = this.items.filter(each => matchesSearch(each) && !each.qtyAdded && each.productId!==null && each.product.category && (each.product?.complianceType?.toLowerCase()==='accessory' || (each.thc!==null && each.cbd!==null && each.totalTerp!==null)))
      }else if(selectedType==='yellow'){
        this.table.rows = this.items.filter(each => matchesSearch(each) && !each.qtyAdded && each.productId && each.product.category && (each.product?.complianceType?.toLowerCase()!=='accessory' && (each.thc===null || each.cbd===null || each.totalTerp==null)))
      }else if(selectedType==='grey'){
        this.table.rows = this.items.filter(each => matchesSearch(each) && ((each.masterProductId!==null && each.productId===null) || (each.product && !each.product.category)))
      }else if(selectedType==='red'){
        this.table.rows = this.items.filter(each => matchesSearch(each) && each.masterProductId===null && each.productId===null)
      }else{
        this.table.rows = this.items.filter(each => matchesSearch(each))
      }

      this.table.totalRecords = this.table.rows.length
      this.table.loading = false
      // if current page is more than total pages, set to page 1
      if(Math.ceil(this.table.rows.length/this.table.pagesize)<this.table.page){
        this.table.page = 1
      }
    },
    back(){
      this.$router.push({ name: 'PurchaseOrdersV2' })
    },
    getNumberOnly(key){
      if(this.form[key].value) return 0
      return this.form[key].value.replace(/\D/, '')
    },
    async updatePurchaseOrder(){
      if(!this.loading){
        this.disableConfirmInventory = true
        let shippingCost = this.form.shippingCost.value
        let tax = this.form.tax.value
        let total = this.form.total.value
        let data = {
          shipmentId: this.form.shipmentId.value,
          createdByName: this.form.createdByName.value,
          shippingCost: shippingCost,
          tax: tax,
          total: total,
          locationId: this.form.location.value,
          fullfillmentTime: this.form.fullfillmentTime.value
        }
        let res = await ProductApi.updatePurchaseOrderById(this.$route.params.id, data)
        if(res.status==200){
          this.shipmentId = res.data.payload.shipmentId
          this.payload.fullfillmentTime = res.data.payload.fullfillmentTime
        }else{
          this.form.shipmentId.value = this.shipmentId
        }
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        this.disableConfirmInventory = false
      }
    },
    /**
     * Select the item
     */
     selectedRow(item, $event) {
      if(!$event.target?.getElementsByTagName('input')?.length && $event.target.nodeName!=='INPUT'){
        // Select unselect the item
        if(this.activeItem.id) {
          let oldactive = document.getElementsByClassName('id-'+this.activeItem.id);
          if(oldactive.length > 0){
            oldactive[0].classList.remove("active-row");
          }
        }
        this.activeItem = item;
        let newActive = document.getElementsByClassName('id-' + this.activeItem.id);
        if(newActive.length > 0){
          newActive[0].classList.add("active-row");
        }

        // edit or  add product
        if((item.masterProduct && item.product===null) || (item.product && item.product?.category===null)){
          // grey product
          // get from product detail only if no master product available
          if(!item.masterProduct && item.product){
            let masterProductFromProduct = ProductHelper.getPoMasterProductFromProduct(item.product)
            item.masterProduct = masterProductFromProduct
          }
          let obj = {add: false, edit: false, grey:true, asn: item, fulfillment: this.payload.fullfillmentTime, editItem: item.masterProduct}
          obj.editItem.size = obj.editItem.size?obj.editItem.size:'N/A'
          this.$emit('toggleAddEdit', obj)
        }else if(item.product && item.qtyAdded){
          // blue product
          this.$emit('toggleAddEdit', {disabled: true, add: false, edit: true, grey:false, asn: item, fulfillment: this.payload.fullfillmentTime, editItem: item.product})
        }else if(item.product && !item.qtyAdded){
          // yellow and green product
          this.$emit('toggleAddEdit', {add: false, edit: true, grey:false, asn: item, fulfillment: this.payload.fullfillmentTime, editItem: item.product})
        }else{
          // red product
          let data = {
            id: item.id,
            name: item.name,
            thc: item.thc,
            thc_min: item.thcMin,
            thc_max: item.thcMax,
            cbd: item.cbd,
            cbd_min: item.cbdMin,
            cbd_max: item.cbdMax,
            brand_id: item.brandModel?.id,
            size: item?.variantName?item?.variantName:'N/A',
            complianceType: item.complianceType?item.complianceType:'',
            strain: "",
            weight_equivalent_dry_cannabis: '',
            producer: null
          }
          this.$emit('toggleAddEdit', {add: false, edit: false, grey:true, asn: item, fulfillment: this.payload.fullfillmentTime, editItem: data})
        }
      }
    },
    addProduct(){
      this.addProductModal = false
      this.$emit('toggleAddEdit', {add: true, edit: false, grey: false, asn: this.payload, editItem: {}})
    },
    async confirmInventory(){
      this.confirmNew(null, '<div class="text-center justify-center text-white text-xl font-bold font-[\'Roboto\'] leading-6 tracking-tight">Are you sure you want to confirm inventory?</div> <br/> <div class="text-center justify-center text-white text-base font-normal font-[\'Roboto\'] leading-5">The purchase order will be moved to complete, and you will have to edit product details from the product list.</div>', 'Continue', null, 'Cancel', null, false, true).then(async () => {
        await this.processConfirmInventory()
      }).catch(err => {
        console.log(err)
      })
    },
    async confirmIndividualOrder(id){
      this.confirmNew(null, '<div class="flex items-center font-bold">Are you sure you want to confirm inventory?</div><div class="mt-2">This product will be moved to ‘Confirmed Inventory’, and will be live and sellable. You will have to edit product details from the product list.</div>', 'Continue', null, 'Cancel', null, false, true).then(async () => {
        this.va_spinner(true)
        let res = await ProductApi.confirmIndividualOrder(this.$route.params.id, {"itemIds": [id]})
        this.snackbar.add({
            type: 'info',
            text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          })
        if(res.status==200){
          await this.fetchList(false)
        }
        this.va_spinner(false)
      }).catch(err => {
        console.log(err)
      })
    },
    async processConfirmInventory(){
      if(!this.shipmentId?.trim()){
        this.snackbar.add({
            type: 'info',
            text: 'Shipping ID is required',
            duration: 3000,
          })
        return 
      }
      if(this.$route.params.id){
        let shippingCost = this.form.shippingCost.value
        let tax = this.form.tax.value
        let total = this.form.total.value
        this.va_spinner(true)
        let data = {
          createdByName: this.form.createdByName.value,
          shippingCost: shippingCost,
          tax: tax,
          total: total,
          locationId: this.form.location.value,
          fullfillmentTime: this.form.fullfillmentTime.value,
          completedByName: this.vg_user.name,
          completedById: this.vg_user.id
        }
        let resUpdate = await ProductApi.updatePurchaseOrderById(this.$route.params.id, data)
        if(resUpdate.status!==200){
          this.snackbar.add({
            type: 'info',
            text: resUpdate.status == 200 ? resUpdate.data.message : Helpers.catchErrorMessage(resUpdate.response.data),
            duration: 3000,
          })
        }

        let res = await ProductApi.confirmPurchaseOrder(this.$route.params.id)
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        if(res.status == 200 || Helpers.catchErrorMessage(res.response.data)==='This Purchase Order has been completed'){
          this.va_setPurchaseOrderWarning(false)
          this.$router.push({ name: 'ViewPurchaseOrders', params: {id: this.$route.params.id} })
        }
        this.va_spinner(false)
      }
    },
    async updateField(type, data, e) {
      if(type==='thc'){
        data.thc = e.target.value?parseFloat(e.target.value):null
      }else if(type==='cbd'){
        data.cbd = e.target.value?parseFloat(e.target.value):null
      }else if(type==='totalTerp'){
        data.totalTerp = e.target.value?parseFloat(e.target.value):null
      }else if(type==='variantName'){
        data.variantName = e.target.value ? e.target.value : ''
      }else if(type==='name'){
        data.name = e.target.value ? e.target.value : ''
      }else if(type==='nou'){
        data.nou = e.target.value ? parseFloat(e.target.value) : ''
      }
      
      
      let res = await ProductApi.updateProductOrderItems({items: [data]})
      if(res.status===200){
        // refresh list if thc, cbd and totalTerp filled or removed
        if((data.thc && data.cbd && data.totalTerp) || (!data.thc && !data.cbd && !data.totalTerp)){
          this.fetchList(false)
          document.activeElement.blur()
        }
      }
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },
    removeProduct(product){
      this.confirmNew('Remove Product', `Are you sure you want to remove <b>${product.name}</b> from the Purchase Order?`, 'Yes', 'bg-theme-red text-white').then(async () => {
        this.va_spinner(true)
        let res = await ProductApi.removePOV2(this.payload.id, {itemId: product.id})
        if(res.status===200){
          await this.fetchList(false)
        }
        this.snackbar.add({
          type: 'info',
          text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
          duration: 3000,
        })
        this.va_spinner(false)
      }).catch(err => {
        console.log(err)
      })
    },
    ...mapMutations({
      vm_complianceType: 'product/complianceType',
    }),
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
      va_setPurchaseOrderWarning: 'purchaseOrderWarn/setPurchaseOrderWarning'
    })
  }
})
</script>
